// url.js
import { BASE_URL } from './root_url';
export const ROOT_URL = `${BASE_URL}`;
export const MOBILE_URL = `${BASE_URL}/v1/mobile`;

// auth
export const CHECK_TAKEN = `${BASE_URL}/v1/baseuser/checktaken/`;
export const FORGET_USERNAME_URL = `${BASE_URL}/v1/mobile/account/forgot-username/`;
export const FORGET_PASSWORD_URL = `${BASE_URL}/v1/mobile/account/forgot-password/`;
export const LOGIN_URL = `${BASE_URL}/api-token-auth/`;
export const RESET_PASSWORD_URL = `${MOBILE_URL}/account/change-password/`;
export const RESET_EMAIL_URL = `${MOBILE_URL}/account/req-reset-password/`;
export const RESET_PASSWORD = `${MOBILE_URL}/account/reset-password/`;
export const SIGNUP_URL = `${BASE_URL}/v1/baseuser/register/customer/`;
export const SEND_VERIFICATION_CODE = `${MOBILE_URL}/account/verify-active/`;
export const CHANGE_PASSWORD = `${MOBILE_URL}/account/change-password/`;
export const BUSINESS_SIGNUP = `${BASE_URL}/v1/baseuser/business-info`;
export const GUEST_SIGNUP = `${BASE_URL}/v1/baseuser/register/customer_guest/`

// profile
export const ADDRESS_URL = `${MOBILE_URL}/address`;
export const CUSTOMER_INFORMATION_URL = `${BASE_URL}/v1/customer/oao/`;
export const DEFAULT_ADDRESS_URL = `${MOBILE_URL}/address/default`;
export const USER_CONFIG_URL = `${MOBILE_URL}/user_config`;
export const VERIFY_EMAIL_URL = `${MOBILE_URL}/account/verify_email_req`;
export const UPDATE_USER_PHOTO = `${MOBILE_URL}/account/upload_profile`;

// product
export const BILLBOARD_URL = `${MOBILE_URL}/billboard/`;
export const CATEGORY_URL = `${MOBILE_URL}/category/`;
export const DISPLAY_CATEGORY_URL = `${MOBILE_URL}/category_display/`;
export const CATEGORY_2_URL = `${MOBILE_URL}/category2/`;
export const CATEGORY_2_B2B_URL = `${MOBILE_URL}/category2_b2b/`;
export const PRODUCTS_URL = `${MOBILE_URL}/product/`;
export const SEARCH_PRODUCT_URL = `${MOBILE_URL}/product/?Name=`;
export const PRODUCTS_GROUP = `${MOBILE_URL}/group`;
export const DISPLAY_PRODUCTS_GROUP = `${MOBILE_URL}/group_display`;
export const PRODUCT_RECIPE_URL = `${BASE_URL}/v1/product/recipe/?products__contains=`;

// checkout
export const ANYWHERE_COMMERCE_URL = `${BASE_URL}/v1/acpayment/store_card/`;
export const CHECKOUT_URL = `${MOBILE_URL}/order/`;
export const CHECKOUT_TOUR_URL = `${MOBILE_URL}/consolidated-checkout/`;
export const VALIDATE_DELIVERY_RADIUS_URL = `${MOBILE_URL}/check_address_location`;
export const VALIDATE_PROMO_CODE_URL = `${MOBILE_URL}/promocode`;
export const ZIPCODE_URL = `${BASE_URL}/v1/purchase/taxarea/`
export const ZIPCODE_URL_NO_LOGIN = `${BASE_URL}/v1/purchase/taxareanotlogin/`
export const SAVE_PAYPAL_DATA = `${BASE_URL}/v1/sale/payment/paypal_payment_save`;

// order
export const CONSOLIDATED_ORDERS_URL = `${MOBILE_URL}/consolidated-orders`;
export const DISPATCH_PORTAL_URL = `${BASE_URL}/v1/sale/sales_mobile_order/external`;
export const MOBILE_SALES_ORDERS_URL = `${BASE_URL}/v1/sale/sales_mobile_order/search/`;
export const ORDER_URL = `${MOBILE_URL}/order/`;
export const PENDING_ORDERS_URL = `${MOBILE_URL}/pending-orders`;
export const SALES_ORDER_URL = `${MOBILE_URL}/sales_order/`;
export const SALES_INVOICE_URL = `${MOBILE_URL}/sales_invoice/`;

// blog
export const BLOG_URL = `${BASE_URL}/v1/product/blog/`;
export const BLOG_COMMENT_URL = `${BASE_URL}/v1/product/comment_blog/`;
export const BLOG_PAGINATE_URL = `${BASE_URL}/v1/product/blog_paginator?limit=16`;

// recipe
export const RECIPE_URL = `${BASE_URL}/v1/product/recipe/`;
export const RECIPE_PAGINATE_URL = `${BASE_URL}/v1/product/recipe_paginator?`;
export const RECIPE_COMMENT_URL = `${BASE_URL}/v1/product/comment_recipe/`;
export const RECIPE_OPTION_URL = `${BASE_URL}/v1/product/recipe_option`;

// contact
export const CONTACT_URL = `${BASE_URL}/v1/contact/info/`;

//cart
export const CART_URL = `${BASE_URL}/v1/mobile/cart`

// become a driver
export const DRIVERAPPLY = `${BASE_URL}/v1/baseuser/mmdriver-application`

// shipstation API
export const SHIPSTATION_API = `${BASE_URL}/v1/sale/shipping/rate_lookup/`;

// ach API
export const ACH_PROFILE_URL = `${BASE_URL}/v1/customer/authorize_profiles/`;



// WEBPACK FOOTER //
// ./src/api/url.js